<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <!--<tt-input ttLabel="defaultcounter_keyno" [ttModel]="edit.defaultcounter_keyno" ttReadonly></tt-input>-->
        <tt-input ttLabel="counter_id" [ttModel]="edit.counter_id" ttReadonly></tt-input>
        <tt-input ttLabel="counter_information" [ttModel]="edit.counter_information" ttReadonly></tt-input>
        <tt-textarea ttLabel="defaultcounter_description" [ttModel]="edit.defaultcounter_description" ttReadonly></tt-textarea>
        <tt-input-number ttLabel="lastnumber_in_this_database" [ttModel]="edit.lastnumber_in_this_database" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
        <tt-input-number ttLabel="counter_nextnumber" [(ttModel)]="edit.counter_nextnumber" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button-save ttText="businesscodefaultcounter_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
